export const environment = {
    production: true,

    assetsUrl: '',

    baseUrl: 'http://192.168.88.114:1883/kunyouapi/',
    HbaseUrl: 'https://www.kunyoutech.com.tw/KunYouHomePage/',

    projectTitleCH: 'KunYou 坤侑科技 | 時刻創新，提供專業客製化解決方案',

    firebase: {},

    debug: true,
    log: {
        auth: false,
        store: false,
    },

    version: 'v2.0.76',
};
